var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('Gnb'),_c('Top'),_c('SiteInfo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }